import _slicedToArray from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useIsomorphicEffect } from '@mantine/hooks';
import { useMantineDefaultProps, useMantineTheme } from '@mantine/styles';
var defaultProps = {
  zIndex: 1,
  position: "relative"
};

function Portal(props) {
  var _useMantineDefaultPro = useMantineDefaultProps("Portal", defaultProps, props),
      children = _useMantineDefaultPro.children,
      zIndex = _useMantineDefaultPro.zIndex,
      target = _useMantineDefaultPro.target,
      className = _useMantineDefaultPro.className,
      position = _useMantineDefaultPro.position;

  var theme = useMantineTheme();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  var ref = useRef();
  useIsomorphicEffect(function () {
    setMounted(true);
    ref.current = !target ? document.createElement("div") : typeof target === "string" ? document.querySelector(target) : target;

    if (!target) {
      document.body.appendChild(ref.current);
    }

    return function () {
      !target && document.body.removeChild(ref.current);
    };
  }, [target]);

  if (!mounted) {
    return null;
  }

  return createPortal( /* @__PURE__ */React.createElement("div", {
    className: className,
    dir: theme.dir,
    style: {
      position: position,
      zIndex: zIndex
    }
  }, children), ref.current);
}

Portal.displayName = "@mantine/core/Portal";
export { Portal };